/* eslint-disable no-unused-vars */

/* eslint-disable class-methods-use-this */
import axios from "axios";

import {
  API_ANNOUNCEMENT_URL,
  API_PRODUCT_ATTRIBUTE_URL,
  COMMON_HEADER_CONFIG
} from "src/config";

class ItemAttributeService {
  getAccessToken = () => localStorage.getItem("accessToken");

  getAttributes = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PRODUCT_ATTRIBUTE_URL}/product/attributes`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          size: 100,
          page: 1,
          admin_name: params?.admin_name
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getItemAttribute = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_PRODUCT_ATTRIBUTE_URL}/product/attribute/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createItemAttribute = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_PRODUCT_ATTRIBUTE_URL}/product/attribute`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateItemAttribute = (data) =>
    new Promise((resolve, reject) => {
      const dataUpdate = JSON.stringify(data);
      const config = {
        method: "patch",
        url: `${API_PRODUCT_ATTRIBUTE_URL}/product/attribute/${data.id}`,
        data: dataUpdate,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getItemType = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ANNOUNCEMENT_URL}/meta-data?type=product_type&platform_key=centralweb&sort=created_at%20desc`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const itemAttributeService = new ItemAttributeService();

export default itemAttributeService;
